import * as React from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import Prose from '@/components/Prose'
import listItem from '@/svg/list-item'

import { fadeIn } from '@/lib/utils/framer-motion-config'

import { StandardPageQuery_entry_page_page_Entry_modules_modules_accordion_BlockType_children_modules_accordionItem_BlockType } from '@/gql/types/StandardPageQuery'

type SingleAccordionType = {
    index: Number
    expanded: Number | false
    setExpanded: Function
    data: StandardPageQuery_entry_page_page_Entry_modules_modules_accordion_BlockType_children_modules_accordionItem_BlockType
}

const SingleAccordion: React.FunctionComponent<SingleAccordionType> = ({
    index,
    expanded,
    setExpanded,
    data,
}) => {
    const isOpen = index === expanded

    // By using `AnimatePresence` to mount and unmount the contents, we can animate
    // them in and out while also only rendering the contents of open accordions
    return (
        <>
            <motion.div
                className="cursor-pointer pt-4 pb-4 text-lg font-black sm:text-3xl md:pt-6 lg:pb-6"
                onClick={() => setExpanded(isOpen ? false : index)}
                {...fadeIn}
            >
                <motion.span
                    className="mr-3 inline-block fill-current"
                    initial={false}
                    animate={{ rotate: isOpen ? -45 : 0 }}
                    transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
                >
                    {listItem()}
                </motion.span>
                {data!.heading}
            </motion.div>
            <motion.div {...fadeIn}>
                <AnimatePresence initial={false}>
                    {isOpen && (
                        <motion.section
                            key="content"
                            initial="collapsed"
                            animate="open"
                            exit="collapsed"
                            variants={{
                                open: { opacity: 1, height: 'auto' },
                                collapsed: { opacity: 0, height: 0 },
                            }}
                            transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
                        >
                            <motion.div
                                variants={{ collapsed: { scale: 0.95 }, open: { scale: 1 } }}
                                transition={{ duration: 0.8 }}
                                className="content-placeholder pb-6"
                            >
                                <Prose html={data!.description!} />
                            </motion.div>
                        </motion.section>
                    )}
                </AnimatePresence>
            </motion.div>
        </>
    )
}

export default SingleAccordion
